import {Component, Input} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
	selector: 'tvsub-pirte',
	templateUrl: './pirte.component.html',
	styleUrls: ['./pirte.component.scss'],
	standalone: false
})
export class PirteComponent {
	@Input()
	description: string;
	@Input()
	form: FormGroup;
	@Input()
	name: string;
	@Input()
	title: string;
	@Input()
	showErrors: boolean;

	get control(): FormControl | null {
		return this.form?.get(`htmlDescriptions.${this.name}`) as FormControl;
	}

	get requiredError(): boolean {
		return this.control?.hasError('required') || false;
	}
}
